class xinJiangWeiWuErCultureTooltip {
  constructor(opt) {
    this.timer = opt.timer
    this.intervalHandle = null
    this.vm = opt.vm
    this.index = 1
    this.mapJson = null
    this.tooltipData = null
  }
  dispatchLoopSelectAction(opt) {
    this.initDom(opt)
    this.startLoop(opt)
  }
  startLoop(opt) {
    clearInterval(this.intervalHandle)
    this.intervalHandle = null
    this.intervalHandle = setInterval(() => {
      this.removeOldToolTop()
      this.index = this.index + 1 >= this.tooltipData.length ? 0 : this.index + 1
      this.createDom(this.tooltipData[this.index], opt) //绘制dom
    }, this.timer)
  }
  initDom(opt) {
    this.removeOldToolTop() //移出之前的dom
    this.initMapJson() //初始化当前地图的json文件
    this.createDom(this.tooltipData[this.index++], opt) //绘制dom
  }
  initMapJson() {
    const name = this.vm.options.chartOption.name
    const mapName = name === "全国" ? "china" : name.split("/").reverse()[0]
    const mapJson = this.vm.$echarts.getMap(mapName)
    this.mapJson = mapJson
  }
  removeOldToolTop() {
    const el = this.vm.$el
    const oldNode = el.getElementsByClassName("xinJiangWeiWuErCultureTooltip")[0]
    if (oldNode) el.removeChild(oldNode)
  }
  // 创建展示弹窗
  createDom(mapData, option) {
    if (!mapData || !option) return
    option.geo3D.regions = [
      {
        name:  mapData.city,
        itemStyle: {
          color: option.selectColor,
        },
      }
    ]
    this.vm.$refs.map.setOption(option, { notMerge: true });

    const wrapper = this.createWrapper()
    const head = this.createHead(mapData.city)
    const splitLine = this.createSplitLine()
    const content = this.createContent(mapData.value)
    wrapper.appendChild(head)
    wrapper.appendChild(content)
    wrapper.appendChild(splitLine)
    this.vm.$el.appendChild(wrapper)
  }
  // 区域内容
  createContent(data) {
    const content = document.createElement("div")
    this.createStyle(content, {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "14px"
    })
    data.forEach((data, index) => {
      const mark = document.createElement("div")
      const item = document.createElement("div")
      const name = document.createElement("span")
      const value = document.createElement("span")
      name.innerText = data.name + ":"
      let markStyle = {
        marginRight: "4px",
        width: "6px",
        height: "6px",
        transform: "rotate(45deg)",
        borderRadius: "1px",
        display: "inline-block"
      }
      if(index === 0){
        this.createStyle(mark, { ...markStyle, backgroundColor: "rgba(0, 224, 255, 1)" })
      }else if(index === 1){
        this.createStyle(mark, { ...markStyle, backgroundColor: "rgba(254, 167, 65, 1)" })
      }else{
        this.createStyle(mark, { ...markStyle, backgroundColor: "rgba(75, 205, 122, 1)" })
      }
      this.createStyle(name, { marginRight: "5px", color: "rgba(218, 229, 229, 1)" })
      this.createStyle(item, { marginBottom: "8px" })
      this.createStyle(value, { color: "rgba(255, 255, 255, 1)" })
      value.innerText = data.value
      item.appendChild(mark)
      item.appendChild(name)
      item.appendChild(value)
      content.appendChild(item)
    })
    return content
  }
  //底部线条
  createSplitLine() {
    const line = document.createElement("div")
    this.createStyle(line, {
      height: "0px",
      width: "122px",
      borderBottom: "1px solid rgba(0, 224, 255, 0.4)",
      marginTop: "4px",
      marginBottom: "10px"
    })
    return line
  }
  // 创建标题：区域名称
  createHead(name) {
    const head = document.createElement("div")
    head.innerText = name
    this.createStyle(head, {
      fontWeight: "600",
      fontSize: "12px",
      height: "24px",
      lineHeight: "14px",
      textAlign: "left",
      marginBottom: "8px",
      "-webkit-background-clip": "text",
      "-webkit-line-clamp": "1",
      color: "transparent",
      backgroundImage: "-webkit-linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)),-webkit-linear-gradient(180deg, rgba(255, 255, 255, 0) 16.67%, rgba(0, 224, 255, 0.35) 100%)",
    })
    return head
  }
  // div外框
  createWrapper() {
    const wrapper = document.createElement("div")
    wrapper.className = "xinJiangWeiWuErCultureTooltip"
    this.createStyle(wrapper, {
      width: "150px",
      height: "120px",
      padding: "12px 12px",
      position: "absolute",
      right: "48px",
      top: "79px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      background:
          "linear-gradient(0deg, #081C2C, #081C2C),linear-gradient(180deg, rgba(8, 28, 44, 0) 0%, rgba(8, 31, 49, 0.00492181) 34.92%, rgba(12, 138, 255, 0.2) 112.46%)",
      boxShadow: "0px 2px 8px 0px #00E0FF54",
      backdropFilter: "blur(32px)"
    })
    return wrapper
  }
  createStyle(dom, style) {
    Object.keys(style).forEach(styleName => {
      dom.style[styleName] = style[styleName]
    })
  }
  updateData(k, v) {
    if (this.hasOwnProperty(k)) {
      this[k] = v
    } else {
      console.error("没有这个数据名：" + k)
    }
  }
}

export default {
  data() {
    return {
      xinJiangWeiWuErCultureTooltip: new xinJiangWeiWuErCultureTooltip({
        timer: 3000,
        vm: this
      })
    }
  },
  methods: {
    async xinJiangWeiWuErCultureTooltipPlugin(opt, self) {
      if(!opt){
        return
      }
      clearInterval(this.xinJiangWeiWuErCultureTooltip.intervalHandle)
      const tooltipData = await Promise.resolve([
        {
          city: "乌鲁木齐市",
          value: [
            { name: "场馆", value: "74" },
            { name: "资讯", value: "0" },
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "克拉玛依市",
          value: [
            { name: "场馆", value: "29" },
            { name: "资讯", value: "5"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "吐鲁番市",
          value: [
            { name: "场馆", value: "37" },
            { name: "资讯", value: "4"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "哈密市",
          value: [
            { name: "场馆", value: "33" },
            { name: "资讯", value: "0"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "昌吉回族自治州",
          value: [
            { name: "场馆", value: "127" },
            { name: "资讯", value: "4"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "博尔塔拉蒙古自治州",
          value: [
            { name: "场馆", value: "57" },
            { name: "资讯", value: "4"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "巴音郭楞蒙古自治州",
          value: [
            { name: "场馆", value: "30" },
            { name: "资讯", value: "4"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "阿克苏地区",
          value: [
            { name: "场馆", value: "102" },
            { name: "资讯", value: "0"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "克孜勒苏柯尔克孜自治州",
          value: [
            { name: "场馆", value: "19" },
            { name: "资讯", value: "3"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "喀什地区",
          value: [
            { name: "场馆", value: "98" },
            { name: "资讯", value: "1"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "和田地区",
          value: [
            { name: "场馆", value: "83" },
            { name: "资讯", value: "3"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "伊犁哈萨克自治州",
          value: [
            { name: "场馆", value: "80" },
            { name: "资讯", value: "3"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "塔城地区",
          value: [
            { name: "场馆", value: "65" },
            { name: "资讯", value: "3"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "阿勒泰地区",
          value: [
            { name: "场馆", value: "86" },
            { name: "资讯", value: "0"},
            { name: "活动", value: "0" }
          ]
        },
        {
          city: "自治区直辖县级行政区划",
          value: [
            { name: "场馆", value: "0" },
            { name: "资讯", value: "0"},
            { name: "活动", value: "0" }
          ]
        }
      ])
      this.xinJiangWeiWuErCultureTooltip.updateData("tooltipData", tooltipData)
      this.xinJiangWeiWuErCultureTooltip.dispatchLoopSelectAction(opt) //初始化提示框
      opt.geo3D.itemStyle.shadowColor = "rgb(101,212,241)"
      opt.geo3D.itemStyle.shadowBlur = 10
      opt.geo3D.itemStyle.shadowOffsetX = 5
      opt.geo3D.itemStyle.shadowOffsetY = 5
    }
  },
  beforeDestroy() {
    clearInterval(this.xinJiangWeiWuErCultureTooltip.intervalHandle)
  },
  beforeUpdate() {
    clearInterval(this.xinJiangWeiWuErCultureTooltip.intervalHandle)
  }
}
